import {
  TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_BEGIN,
  TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_FAILURE,
  TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_SUCCESS
} from '../constants'
import { BFFAgent } from 'BFFAgent'

export function reducer(state, action) {
  //TODO: Diferenciar entre compra y venta
  switch (action.type) {
    case TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_BEGIN:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          sellPossibleActionsPending: true
        }
      }
    case TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_SUCCESS:
      const possibleActionsArray = BFFAgent.Stock.TakingCarManagement.mapPossibleActionToOptions(action.data)
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          sellPossibleActions: possibleActionsArray,
          sellPossibleActionsPending: false,
        }
      }
    case TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_FAILURE:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          sellPossibleActionsError: true,
          sellPossibleActionsPending: false
        }
      }
    default:
      return state
  }
}
